import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
    name: 'quick-menu-item'
})
export default class GnbQuickMenuItem extends Vue {
    @Prop({type:Object}) quickMenuItem!: gnb.QuickMenuItem
    @Prop({type:String}) userLang!: string
    
    fnGetQuickMenuName(item: gnb.QuickMenuItem){
        let menuName = ''
        if (item){
            menuName = (this.userLang.toLowerCase() == 'ko-kr' ? item.title : item.titleEn).toString()
        }
        return menuName
    }

    fnExpandSubItem(){
        var expandArrow = this.$el.getElementsByTagName('i');
        var subContent = this.$el.getElementsByClassName('accordion-content')

        if (subContent && expandArrow){
            if (subContent[0].getAttribute('style') === null){
                subContent[0].setAttribute('style', 'display:none');
                expandArrow[0].classList.remove('icon-fux-up')
                expandArrow[0].classList.add('icon-fux-down')
            }
            else{
                subContent[0].removeAttribute('style')
                expandArrow[0].classList.remove('icon-fux-down')
                expandArrow[0].classList.add('icon-fux-up')
            }
        }
    }
}